import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "font-bold flex items-center"
};
const _hoisted_2 = {
  class: "w-full"
};
const _hoisted_3 = {
  class: "font-bold text-right pl-8"
};
const _hoisted_4 = {
  class: "font-bold text-right pl-8"
};
const _hoisted_5 = {
  class: "font-bold text-right pl-8"
};
const _hoisted_6 = {
  class: "font-bold text-right pl-8"
};
const _hoisted_7 = {
  class: "font-bold text-right pl-8"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center"
};
const _hoisted_9 = {
  key: 1,
  class: "text-center mt-2"
};
import Status from "@/modules/vue/components/Status.vue";
import { SponsorTypeEnum } from "@/modules/sponsoring/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'Sponsor',
  props: {
    sponsor: null,
    canBeAccepted: {
      type: Boolean
    },
    muted: {
      type: Boolean
    }
  },
  emits: ['accept'],
  setup(__props) {
    const props = __props;
    const colorMap = ref({
      [SponsorTypeEnum.SAFE]: ColorEnum.Green,
      [SponsorTypeEnum.BALANCED]: ColorEnum.Blue,
      [SponsorTypeEnum.RISKY]: ColorEnum.Red
    });
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["p-4 mb-2 last:mb-0 rounded-xl text-slate-800", {
          'opacity-25': __props.muted,
          'bg-green-50': __props.sponsor.accepted,
          'bg-slate-50': !__props.sponsor.accepted
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(Status, {
        color: colorMap.value[__props.sponsor.type],
        class: "inline-block mr-2"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.sponsor.type), 1)]),
        _: 1
      }, 8, ["color"]), _createTextVNode(" " + _toDisplayString(__props.sponsor.name), 1)]), _createElementVNode("table", _hoisted_2, [_createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('once')), 1), _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$money(__props.sponsor.once)), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('per_league_match')), 1), _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$money(__props.sponsor.perLeagueMatch)), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('per_league_victory')), 1), _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$money(__props.sponsor.perLeagueVictory)), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('per_cup_match')), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$money(__props.sponsor.perCupMatch)), 1)]), _createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('per_cup_victory')), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$money(__props.sponsor.perCupVictory)), 1)])]), __props.sponsor.accepted ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(Status, {
        color: _ctx.ColorEnum.Green
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('accepted')), 1)]),
        _: 1
      }, 8, ["color"])])) : __props.canBeAccepted ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_NButton, {
        type: "success",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('accept'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('accept')), 1)]),
        _: 1
      })])) : _createCommentVNode("", true)], 2);
    };
  }
});